export default __webpack_public_path__ + "static/media/blue-vaccine.83979c4e.svg";